import $ from 'jquery';
import Unit from '../Global/_Unit';

export default class Scroll {
  constructor() {

    // let _scrollHeight = $(window).height() * 0.8;
    // $(".js-lineup__product").height(_scrollHeight);


    // if($(window).width() < 768){
    //   let _scrollHeight = $(".js-lineup__product").height() + $('.lineup__title').height() + 150 + $(window).height() * 0.3;
    //   $(".lineup").height(_scrollHeight);
  
    // } else if($(window).width() > 1360){
      let _scrollHeight = $(".js-lineup__product").height() + $('.lineup__title').height() + 150 + $(window).height() * 0.3;
      $(".lineup").height(_scrollHeight);
  
    // } else {

    //   let _scrollHeight = $(window).height() * 0.8 - ($(window).width() / 980) * 10;
    //   $(".js-lineup__product").height(_scrollHeight);
  
    // }


    // console.log('class Scroll');
    var target = $('.lineup');
    this.filterBg = target.find('.lineup__bg');
    this.filterNavi = target.find('.lineup__filter');
    this.filterNaviSpacer = target.find('.lineup__filterBlockSpacer');
    this.filterNaviLi = target.find('.lineup__filterLi');
    this.startY;
    // this.endY = this.startY + this.targetHeight;
    // console.log(this.targetHeight, target.width(), this.startY);
    this._scrollNaname();
    this._event();
  }

  _scrollNaname() {

    var l1 = $('.js-lineup__product');
    var wh = Math.floor($(window).height());
    var ww = Math.floor($(window).width());
    var eh = l1.height();
    var ew = l1.width();
    var x = (Unit.isPc())? (eh + ew) * 0.55 : (eh + ew) * 0.4;
    var y = (Unit.isPc())? (eh + ew) * 0.7 - wh/2 : (eh + ew) * 0.7;
    // var duration = (eh * 0.7) + (ew * 0.7) - wh / 2;
    var duration = (Unit.isPc())? (eh + ew) * 0.7 - wh / 2 : (eh + ew) - wh / 2;


    // x = 700;
    // y = 648;
    var flightpath = {
      leave: {
        curviness: 1.25,
        // autoRotate: true,
        values: [
          {
            x: x,
            y: -y,
          },
        ],
      },
    };



    // console.log(flightpath);

    // init controller
    window.lineUpcontroller = new ScrollMagic.Controller();
    // create tween
    var tween = new TimelineMax()
      // .add(TweenMax.to($("#plane"), 1.2, {css:{bezier:flightpath.entry}, ease:Power1.easeInOut}))
      .add(TweenMax.to($('.js-lineup__product'), 1, {css:{bezier:flightpath.leave}, ease:Power1.easeInOut}));

    window.lineUpScene = new ScrollMagic.Scene(
      {
        triggerElement: '.lineup__filterBlock',
        // duration: 4000,
        duration: duration,
        // duration: '100%',
        offset: -92,
        triggerHook: 'onLeave',
      })
        .setPin("#js-lineup__product--pin")
        .setTween(tween)
        // .addIndicators()
        .addTo(window.lineUpcontroller);
  }

  _event() {

    $(window).scroll(
      function () {
        var scroll = $(window).scrollTop();
        this.startY = this.filterNaviSpacer.offset().top;
        if (scroll > this.startY - $('.header').outerHeight(true)) {
          this.filterNavi.addClass('lineup__filter--fixed');
          this.filterNavi.css({
            top: $('.header').outerHeight(true),
          });
        } else {
          this.filterNavi.removeClass('lineup__filter--fixed');
          this.filterNavi.css({
            top: 0,
            // position: 'absolute',
          });
        }
      }.bind(this),
    );

    // $(window).scroll(
    //   function () {
    //     var l1 = $('.js-lineup__product');
    //     var elemTop1 = Math.floor(l1.offset().top);
    //     var elemH1 = Math.floor(l1.height());
    //     var mar = 0;
    //     var wh = Math.floor($(window).height());
    //     var ww = Math.floor($(window).width());
    //     var scrollPos = Math.floor($(window).scrollTop() + wh);
    //     var xIdo;
    //     var toriggerPoint = 'center';
    //     var torigger = (toriggerPoint == 'center')? -wh/2 : 0;

    //     // var ido = 300;
    //     // console.log(scrollPos,elemTop1+wh,elemTop1 + wh + torigger);

    //     if (scrollPos > elemTop1 + wh + torigger) {
    //       // var per = ( (scrollPos - elemTop1) / (elemH1+wh)) * 100;
    //       var per =((scrollPos - elemTop1 + torigger) / (elemH1+wh+ torigger) );
    //       console.log(per);

    //       // xIdo = (Unit.isPc())? l1.height() : l1.height() * 0.7;
    //       xIdo = (l1.height() * 0.7) + (l1.width() * 0.7) - ww/2;


    //       l1.css({
    //         // transform: 'translateX(' + 2200 * ~~(per + mar) + 'px)',// eslint-disable-line
    //         transform: 'translateX(' + xIdo * per + 'px)',// eslint-disable-line
    //       });
    //     } else {
    //       l1.css({transform: 'translateX(0px)'});// eslint-disable-line
    //     }
    //     // else this.target.removeClass('header--open');
    //   }.bind(this),
    // );

    // pc
    this.filterNavi.find('.lineup__filterLi').hover(
      function () {
        if (!Unit.isPc()) return false;
        $(this).addClass('lineup__filterLi--open');
        $(this).find('.lineup__filterSub').stop().slideDown(100);
      },
      function () {
        if (!Unit.isPc()) return false;
        $(this).removeClass('lineup__filterLi--open');
        $(this).find('.lineup__filterSub').stop().slideUp(100);
      },
    );

    // sp
    this.filterNavi.find('.lineup__filterLiSpTitle').click(function (event) {
      if (Unit.isPc()) return false;
      $(this).toggleClass('lineup__filterLiSpTitle--open');
      $('.lineup__filterLi').stop().slideToggle(100);

      $(".lineup__bg").toggleClass("sort-open");

    });


    //枠外解除
    this.filterBg.click(function(event){
      $(this).removeClass('sort-open');
      $('.lineup__filterLi').stop().slideToggle(100);
    });



    // $(this.$el).find('.lineup__filterLi').each(function(index, el) {
    //   var li = $(this);
    //   li.find('dt').click(function(event) {
    //     // $('.lineup__filterLi').removeClass('lineup__filterLi--open');
    //     $(el).toggleClass('lineup__filterLi--open');
    //     // $('.lineup__filterSub').stop().slideUp(100);
    //     li.find('.lineup__filterSub').stop().slideToggle(100);
    //   });
    // });


  }
}


// (() => {
//   const targets = $('.lineup');
//   if (!targets.length) return;
//   new Scroll(targets);
// })();
